<template>
  <div class="default-modal login-modal">
    <div class="default-modal__header">
      <h3 class="default-modal__title">Войти по номеру</h3>
      <button type="button" class="default-modal__close" @click="$emit('close')">
        <IconComponent name="add" />
      </button>
    </div>
    <div class="default-modal__body login-modal__body">
      <div class="login-modal__inputs">
        <InputComponent
          v-model="number"
          :error="form.phone.error"
          title="Номер телефона"
          placeholder="+7 (___) ___ - __ - __"
          mask="+7 (###) ### - ## - ##"
          modified
          is-phone
          :disabled="step === 1"
          @enter="userLogin"
        />
        <template v-if="step === 1">
          <InputComponent
            v-model="code"
            :error="form.code.error"
            title="Код"
            mask="####"
            modified
            autofocus
            @enter="phoneConfirm"
          />
          <span>{{ confirmTitle }}</span>
        </template>
      </div>
    </div>
    <div class="default-modal__footer login-modal__footer">
      <template v-if="step === 0">
        <button type="button" class="btn btn--md btn--main" @click="userLogin">
          <FileIconComponent v-if="loading" name="loading" />
          <template v-else>Получить код</template>
        </button>
        <!--        <button type="button" class="btn btn&#45;&#45;md btn&#45;&#45;main-hollow" @click="showEmailLoginModal">-->
        <!--          Войти по email-->
        <!--        </button>-->
      </template>
      <button
        type="button"
        class="btn btn--md btn--main"
        v-if="step === 1"
        @click="phoneConfirm"
        :disabled="!(code && code.length === 4)"
      >
        <FileIconComponent v-if="loading" name="loading" />
        <template v-else>Войти</template>
      </button>
      <TermsAgreeComponent />
    </div>
  </div>
</template>

<script>
import InputComponent from "components/inputs/InputComponent.vue";
import FileIconComponent from "components/FileIconComponent.vue";
import IconComponent from "components/IconComponent.vue";
// import LoginViaEmailModal from "components/modals/components/LoginViaEmailModal.vue";
import WelcomeBonusModal from "components/modals/components/WelcomeBonusModal.vue";
import USER_PHONE_CONFIRM from "gql/auth/UserPhoneConfirm.graphql";
import USER_LOGIN from "gql/auth/UserLogin.graphql";
// import USER_LOGIN_VIA_EMAIL from "gql/auth/UserLoginViaEmail.graphql";
import TermsAgreeComponent from "components/TermsAgreeComponent.vue";
import axios from "axios";

// step 0 - Ввод номера телефона
// step 1 - Ввод кода из смс
export default {
  name: "LoginModal",
  props: {
    routeAfterLogin: Object,
    callback: Function,
  },
  data() {
    return {
      step: 0,
      number: null,
      code: null,
      loading: false,
      form: {
        phone: {
          error: null,
        },
        code: {
          error: null,
        },
      },
      confirmTitle: "Введите код, который придет в смс",
    };
  },
  methods: {
    userLogin() {
      if (!this.loading) {
        if (this.number) {
          this.loading = true;
          this.resetErrors();
          this.$apollo
            .mutate({
              mutation: USER_LOGIN,
              variables: {
                phone: this.number.replace(/(^\+)|(\D+)/g, "$1"),
              },
            })
            .then(({ data }) => {
              if (data.UserLoginViaSite) {
                this.loading = false;
                this.step = 1;
                if (data.UserLogin.message) {
                  this.confirmTitle = data.UserLogin.message;
                }
              }
            })
            .catch(({ graphQLErrors }) => {
              this.loading = false;
              this.parseGqlErrors(graphQLErrors);
            });
        } else {
          this.form.phone.error = "Введите номер телефона";
        }
      }
    },
    resetErrors() {
      Object.keys(this.form).forEach((key) => {
        this.form[key].error = null;
      });
    },
    parseGqlErrors(graphQLErrors) {
      if (!graphQLErrors) return;
      graphQLErrors.forEach((err) => {
        if (err.extensions && err.extensions.category === "validation") {
          Object.keys(err.extensions.validation).forEach((key) => {
            if (this.form[key]) {
              this.form[key].error = err.extensions.validation[key][0];
            }
          });
        }
      });
    },
    showWelcomeBonusModal() {
      this.$store.state._modals = [];
      this.$store.state._modals.push({
        component: WelcomeBonusModal,
        options: {},
      });
    },
    phoneConfirm() {
      if (!this.loading) {
        this.loading = true;
        this.resetErrors();
        this.$apollo
          .mutate({
            mutation: USER_PHONE_CONFIRM,
            variables: {
              code: parseInt(this.code),
            },
          })
          .then(({ data }) => {
            if (data && data.UserPhoneConfirm) {
              const isFirstLogin = data.UserPhoneConfirm.is_first_login;
              this.$store.state.auth.user = data.UserPhoneConfirm.user;
              this.$store.state.apollo_token = data.UserPhoneConfirm.token;

              this.$cookie.set("apollo_token", data.UserPhoneConfirm.token, { expires: "60D" });

              axios({
                method: "post",
                url: "/token",
                data: {
                  token: data.UserPhoneConfirm.token,
                },
                headers: {
                  "Content-Type": "application/json",
                },
              }).then(() => {
                // сохраняем товары в корзине из store, куда они добавлются из localStorage в App.vue
                this.$store
                  .dispatch("CART_ADD_ITEMS", {
                    apollo: this.$apollo,
                    variables: {
                      items: this.$store.state.auth.cart.map((c) => {
                        return {
                          id: c.item.id,
                          count: c.count,
                        };
                      }),
                    },
                  })
                  .then(() => {
                    this.$store.dispatch("ME", {
                      apollo: this.$apollo.provider.defaultClient,
                    });
                  });

                if (isFirstLogin) {
                  this.showWelcomeBonusModal();
                } else if (this.routeAfterLogin) {
                  this.$router
                    .push(this.routeAfterLogin)
                    .then(() => {
                      this.loading = false;
                      this.$emit("close");
                    })
                    .catch(() => {
                      this.loading = false;
                      this.$emit("close");
                    });
                } else {
                  this.$emit("close");
                }

                if (this.callback) {
                  this.callback();
                }
              });
            }
          })
          .catch(({ graphQLErrors }) => {
            this.loading = false;
            this.parseGqlErrors(graphQLErrors);
          });
      }
    },
  },
  components: { TermsAgreeComponent, FileIconComponent, IconComponent, InputComponent },
};
</script>

<style lang="stylus">
.login-modal {
  width 100%
  max-width 453px

  &__inputs {
    width 100%
    display grid
    grid-gap 20px

    .input {
      width 100%

      &__container {
        border-color var(--main-color-75)
      }

      &__field {
        font-size: 1.125em
        line-height: 20px;
      }
    }
  }

  &__input {
    display grid
    grid-gap 5px
    width 100%
  }

  &__inputs-title {
    display flex
    align-items center
    gap 8px
    width 100%
    font-weight: normal;
    font-size: 0.875em;
    line-height: 20px;
    color: var(--body-color-muted);
  }

  &__body > .input {
    width 100%
  }

	&__footer {
		.terms__agree {
			align-self: flex-start
		}
	}

  &__footer .btn {
    width 100%
    justify-content center
  }
}
</style>
